import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Wrap a route that requires authentication.
 * Optional `role` prop: "admin" | "customer"
 *  - If set, the user must have that role; otherwise redirected.
 */
export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-pv-green font-display font-bold animate-pulse">
          Cargando...
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (role && user.role !== role) {
    // Role mismatch -> send to the right home for their role
    const dest = user.role === "admin" ? "/admin" : "/perfil";
    return <Navigate to={dest} replace />;
  }
  return children;
}
